/**
 * @param {number} value The input absolute value
 * @param {number} sum The sample size
 * @param {Object} hints The hints object
 * @param {boolean} [hints.absolute]
 * @return {number|string} If `hints.absolute` is truthy returns the absolute value else a percentage with 1 decimal
 */
export const percentualize = (value, sum, hints) => hints.absolute ? value : (parseFloat(sum ? (value / sum * 100).toFixed(1) : 0));
